import ErrorTypeEnum from '../../../common/constants/enums/ErrorTypeEnum';
import BaseApplicationError from '../../../common/models/errors/base/BaseApplicationError';

class NotFound404Error extends BaseApplicationError {
  public readonly type = ErrorTypeEnum.NotFound404;
}

export default NotFound404Error;
